import 'bootstrap/dist/css/bootstrap.min.css';
import { useState } from 'react';
import './FilterModal.css';

const FilterModal = ({ filterOptions, handleApply, selectedFilter }) => {
  const [activeFilter, setActiveFilter] = useState(selectedFilter);

  // Handle radio button selection
  const handleRadioChange = (event) => {
    setActiveFilter(event.target.value);
  };

  // const clearFilter = () => {
  //     setActiveFilter(""); // Clear the active filter
  //     handleApply(""); // Pass an empty filter to parent
  // };

  return (
    <div className="dropdown-menu show" style={{ padding: '15px', minWidth: '200px' }}>
      {filterOptions?.map((filter, index) => (
        <div className="form-check" key={index}>
          <input
            type="radio"
            id={filter.value}
            name="filter"
            value={filter.value}
            className="form-check-input"
            checked={activeFilter === filter.value}
            onChange={handleRadioChange}
          />
          <label htmlFor={filter.value} className="form-check-label">
            {filter.label}
          </label>
        </div>
      ))}

      {/* Select All Option */}
      <div className="form-check mt-2">
        <input
          type="radio"
          id="select-all"
          name="filter"
          value=""
          className="form-check-input"
          checked={activeFilter === ''}
          onChange={() => setActiveFilter('')}
        />
        <label htmlFor="select-all" className="form-check-label">
          Select All
        </label>
      </div>

      {/* Apply Button */}
      <button className="btn btn-primary mt-3 w-100" onClick={() => handleApply(activeFilter)}>
        Apply
      </button>

      {/* Clear Filter Button */}
      {/* <button className="btn btn-secondary mt-2 w-100" onClick={clearFilter}>
                Clear Filter
            </button> */}
    </div>
  );
};

export default FilterModal;
